import { ActionContext, Module } from "vuex";
interface State {
  tickets: Array<any>;
  attachment: Array<any>;
  pagination: any;
  paginationAttachment: any;
  typetickets: Array<any>;
  requestsItem: Array<any>;
  serviceCategoryItem: Array<any>;
  statusitem: Array<any>;
  sitesitem: Array<any>;
  impactitem: Array<any>;
  urgencyitem: Array<any>;
  categoryitem: Array<any>;
  subcategoryitem: Array<any>;
  items: Array<any>;
  priorityitems: Array<any>;
  commentitems: Array<any>;
  detailtickets: any;
}
import axios from "@/lib/axios";
import { async } from "rxjs";
const store: Module<State, any> = {
  namespaced: true,
  state: {
    tickets: [],
    pagination: {},
    paginationAttachment: {},
    typetickets: [],
    requestsItem: [],
    serviceCategoryItem: [],
    statusitem: [],
    sitesitem: [],
    impactitem: [],
    urgencyitem: [],
    categoryitem: [],
    subcategoryitem: [],
    items: [],
    priorityitems: [],
    detailtickets: {},
    commentitems: [],
    attachment: [],
  },
  mutations: {
    settickets: (state: State, payload: any) => (state.tickets = payload),
    setattachment: (state: State, payload: any) => (state.attachment = payload),
    setpagination: (state: State, payload: any) => (state.pagination = payload),
    setpaginationAttachment: (state: State, payload: any) =>
      (state.paginationAttachment = payload),
    settickettype: (state: State, payload: any) =>
      (state.typetickets = payload),
    setrequesttype: (state: State, payload: any) =>
      (state.requestsItem = payload),
    setServiceCategoryItem: (state: State, payload: any) =>
      (state.serviceCategoryItem = payload),
    setstatus: (state: State, payload: any) => (state.statusitem = payload),
    setsites: (state: State, payload: any) => (state.sitesitem = payload),
    setimpact: (state: State, payload: any) => (state.impactitem = payload),
    seturgency: (state: State, payload: any) => (state.urgencyitem = payload),
    setcategory: (state: State, payload: any) => (state.categoryitem = payload),
    setsubcategory: (state: State, payload: any) =>
      (state.subcategoryitem = payload),
    setitem: (state: State, payload: any) => (state.items = payload),
    setpriority: (state: State, payload: any) =>
      (state.priorityitems = payload),
    setdetailticket: (state: State, payload: any) =>
      (state.detailtickets = payload),
    setcomment: (state: State, payload: any) => (state.commentitems = payload),
  },
  getters: {
    getattachment: (state: State) => {
      return state.attachment ? state.attachment : [];
    },
  },
  actions: {
    addticket: async (context: ActionContext<State, any>, payload: any) => {
      return axios.instance.post("/ticket/create", payload);
    },
    addcomment: async (context: ActionContext<State, any>, payload: any) => {
      return axios.instance.post("/ticket/comment/add", payload);
    },
    addattachment: async (context: ActionContext<State, any>, payload: any) => {
      return axios.instance.post("/ticket/comment/attachment", payload);
    },
    deleteattachment: async (
      context: ActionContext<State, any>,
      payload: any
    ) => {
      return axios.instance.delete(
        `/ticket/comment/${payload.ticketId}/attachment/${payload.attachId}`,
        payload
      );
    },
    updatecomment: async (context: ActionContext<State, any>, payload: any) => {
      return axios.instance.post("/ticket/comment/edit", payload);
    },
    fetchticketstype: async (
      context: ActionContext<State, any>,
      payload: any
    ) => {
      return await axios.instance
        .get("/ticket/ticket-type")
        .then((response) => {
          const typeticket = response.data.data;
          context.commit("settickettype", typeticket);
        });
    },
    fetchrequest: async (context: ActionContext<State, any>) => {
      return await axios.instance
        .get("/ticket/request-type")
        .then((response) => {
          const request = response.data.data;
          context.commit("setrequesttype", request);
        });
    },
    fetchServiceCategory: async (context: ActionContext<State, any>) => {
      return await axios.instance
        .get("/ticket/service-category")
        .then((response) => {
          const serviceCategory = response.data.data;
          context.commit("setServiceCategoryItem", serviceCategory);
        });
    },
    fetchstatus: async (context: ActionContext<State, any>) => {
      return await axios.instance.get("/ticket/status").then((response) => {
        const status = response.data.data;
        context.commit("setstatus", status);
      });
    },
    fetchsites: async (context: ActionContext<State, any>) => {
      return await axios.instance.get("/ticket/sites").then((response) => {
        const sites = response.data.data;
        context.commit("setsites", sites);
      });
    },
    fetchimpact: async (context: ActionContext<State, any>) => {
      return await axios.instance.get("/ticket/impact").then((response) => {
        const impact = response.data.data;
        context.commit("setimpact", impact);
      });
    },
    fetchurgency: async (context: ActionContext<State, any>) => {
      return await axios.instance.get("/ticket/urgency").then((response) => {
        const urgency = response.data.data;
        context.commit("seturgency", urgency);
      });
    },
    fetchpriority: async (context: ActionContext<State, any>) => {
      return await axios.instance.get("/ticket/priority").then((response) => {
        const priority = response.data.data;
        context.commit("setpriority", priority);
      });
    },
    fetchcategory: async (context: ActionContext<State, any>) => {
      return await axios.instance.get("/ticket/category").then((response) => {
        const category = response.data.data;
        context.commit("setcategory", category);
      });
    },
    fetchsubcategory: async (context: ActionContext<State, any>) => {
      return await axios.instance
        .get("/ticket/subcategory")
        .then((response) => {
          const subcat = response.data.data;
          context.commit("setsubcategory", subcat);
        });
    },
    fetchitem: async (context: ActionContext<State, any>) => {
      return await axios.instance.get("/ticket/item").then((response) => {
        const item = response.data.data;
        context.commit("setitem", item);
      });
    },
    fetchtickets: async (
      context: ActionContext<State, any>,
      payload: any = { page: 1, itemsPerPage: 10, search: "" }
    ) => {
      const params: {
        page: any;
        limit: any;
        project?: any;
        request_type?: any;
        status?: any;
      } = { page: payload.page, limit: payload.itemsPerPage };
      if (payload.project) {
        params.project = payload.project;
      }
      if (payload.request_type) {
        params.request_type = payload.request_type;
      }
      if (payload.status) {
        params.status = payload.status;
      }
      return axios.instance.get("/ticket/all", { params }).then((response) => {
        const ticket = response.data.data.ticket;
        const pagination = response.data.data.pagination;
        context.commit("settickets", ticket);
        context.commit("setpagination", pagination);
      });
    },
    fetchattachment: async (
      context: ActionContext<State, any>,
      payload: any = { page: 1, itemsPerPage: 10 }
    ) => {
      const params: { page: any; limit: any } = {
        page: payload.page || 1,
        limit: payload.itemsPerPage || 10,
      };
      return axios.instance
        .get(`/ticket/comment/attachment/${payload.id}`, { params })
        .then((response) => {
          const attachments = response.data.data.ticket;
          const pagination = response.data.data.pagination;
          context.commit("setattachment", attachments);
          context.commit("setpaginationAttachment", pagination);
        });
    },
    fetchdetailtiket: async (
      context: ActionContext<State, any>,
      payload: any
    ) => {
      return await axios.instance
        .get(`/ticket/detail/${payload}`)
        .then((response) => {
          const detail = response.data.data;
          context.commit("setdetailticket", detail);
        });
    },
    fetchcomment: async (context: ActionContext<State, any>, payload: any) => {
      return await axios.instance
        .get(`/ticket/comment/${payload}/list`)
        .then((response) => {
          const comment = response.data.data;
          context.commit("setcomment", comment);
        });
    },
  },
};

export default store;
